const apiService = {
  get: (path: string, token: string | null = null) => {
    const headers: Record<string, string> = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    return fetch(`${process.env.REACT_APP_API_BASE}${path}`, {
      headers,
    });
  },
  put: <B = unknown>(path: string, token: string | null = null, body: B) => {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    return fetch(`${process.env.REACT_APP_API_BASE}${path}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(body),
    });
  },
  post: (path: string, token: string | null = null, body: unknown) => {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    return fetch(`${process.env.REACT_APP_API_BASE}${path}`, {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    });
  },
  postFile: (path: string, token: string | null = null, body: FormData) => {
    const headers: Record<string, string> = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    return fetch(`${process.env.REACT_APP_API_BASE}${path}`, {
      method: 'POST',
      headers,
      body: body,
    });
  },
  downloadFile: async (
    path: string,
    filename: string,
    token: string | null = null
  ) => {
    const headers: Record<string, string> = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const res = await fetch(`${process.env.REACT_APP_API_BASE}${path}`, {
      method: 'GET',
      headers,
    });
    // Gross, but it works...
    // I guess this is the best way to download a file
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  },
};
export default apiService;
